import { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Send, Bot, User, ChevronDown } from "lucide-react";

const API_URL = "https://api.commandcode.ai/provider/v1";
const API_KEY = "user_643EezUJCYeooQt4EPs7U7L5JK13hmy3dNjwhxXNFsoUbHMu2zJ2nKxnryGJJyn6RYnxhqRy7ZJBM2B8znEWoeCA";
const MODEL = "xiaomi/mimo-v2.5-pro";

const SYSTEM_PROMPT = `Kamu adalah asisten support resmi OriginPS — sebuah Growtopia Private Server (GTPS) premium.

IDENTITAS:
- Nama: OriginPS AI Support
- Pengembang: OriginPS Team
- Website: https://originps.net
- Server IP: 149.202.58.185
- Discord: [Discord OriginPS](https://discord.gg/cgvcTFXH5d)
- WhatsApp: [WhatsApp Group](https://chat.whatsapp.com/GwYF34utsnl5yocdiQJc5S)
- Download APK: https://cdn.runeria.fun/OriginPS.apk

PANDUAN BERMAIN DETAIL:

**Cara Main di Windows:**
1. Download file hosts.txt dari website OriginPS (tab How to Play → Windows)
2. Buka Notepad sebagai Administrator
3. Buka file C:\\Windows\\System32\\drivers\\etc\\hosts
4. Copy isi hosts.txt ke file tersebut dan simpan
5. Buka Growtopia — otomatis connect ke OriginPS

**Cara Main di Android — Ada 4 Metode:**

**Metode 1 — Download APK OriginPS (termudah):**
1. Download APK dari [link ini](https://cdn.runeria.fun/OriginPS.apk)
2. Install APK (izinkan instalasi dari sumber tidak dikenal)
3. Buka aplikasi OriginPS — langsung connect

**Metode 2 — PowerTunnel:**
1. Download PowerTunnel APK: [VirtualHost.apk](https://cdn.runeria.fun/VirtualHost.apk)
2. Open → Plugin → Hosts → Open the Setting
3. Enter URL: https://originps.net/api/raw/OriginPS
4. Back, click "CONNECT" button, open Growtopia

**Metode 3 — Hosts Go (No Root):**
1. Download Hosts Go APK: [HostGo.apk](https://cdn.runeria.fun/HostGo.apk)
2. Open → Hosts Editor → enable → Download Hosts File
3. Enter URL: https://originps.net/api/raw/OriginPS
4. Apply, start protection, open Growtopia

**Metode 4 — Virtual Host:**
1. Download Virtual Host APK: [VirtualHost.apk](https://cdn.runeria.fun/VirtualHost.apk)
2. Download Hosts File: https://originps.net/api/raw/OriginPS
3. Open → SELECT HOSTS FILE
4. Select the downloaded host file (OriginPS.txt), open Growtopia

**Cara Main di iOS (Surge 5):**
1. Install Surge 5 dari App Store: [Surge 5](https://apps.apple.com/us/app/surge-5/id1442620678)
2. Import Profile: https://originps.net/api/ios/OriginPS
3. Allow VPN Configuration → Connect
4. Open Growtopia

**Informasi Umum:**
- OriginPS adalah server Growtopia Private Server gratis
- Fitur: custom worlds, daily drops, fair economy, anti-cheat, active staff, weekly events, mythic items, low latency, 24/7 online
- Server selalu online dan gratis untuk semua pemain
- Ada 322+ anggota di Discord komunitas

ATURAN PERCAKAPAN:
- Gunakan bahasa Indonesia sebagai bahasa utama
- Support juga: English, Melayu, 中文, 日本語, Türkçe
- Jawab dengan ramah, informatif, dan singkat (max 3-4 paragraf)
- JANGAN ngelantur atau memberikan informasi palsu
- Jika ditanya di luar topik OriginPS, katakan: "Pertanyaan selebihnya bisa bergabung ke [Discord OriginPS](https://discord.gg/cgvcTFXH5d) atau [WhatsApp Group](https://chat.whatsapp.com/GwYF34utsnl5yocdiQJc5S) ya 😊"
- Jika tidak tahu jawabannya, akui dan arahkan ke Discord support
- Jangan pernah memberikan informasi pribadi atau akses admin
- Gunakan emoji secukupnya biar lebih ramah
- Gunakan format markdown **bold**, *italic*, \`code\`, \`\`\`code blocks\`\`\`, dan [link](url) untuk memperjelas informasi
- Jika menyebut link, WAJIB gunakan format markdown [nama](url). Contoh:
  - ✅ [Download OriginPS APK](https://cdn.runeria.fun/OriginPS.apk)
  - ✅ [Discord OriginPS](https://discord.gg/cgvcTFXH5d)
  - ✅ [WhatsApp Group](https://chat.whatsapp.com/GwYF34utsnl5yocdiQJc5S)
  - ❌ JANGAN tulis **Download OriginPS APK** atau **Discord OriginPS** tanpa link
  - ❌ JANGAN tulis URL mentah seperti https://...
  - ❌ JANGAN gunakan HTML atau tag <a> apapun
- SETELAH memberikan jawaban, tambahkan: "Ada yang lain bisa dibantu? Kalau ada kendala atau pertanyaan lebih lanjut, silakan bergabung ke [Discord OriginPS](https://discord.gg/cgvcTFXH5d) atau [WhatsApp Group](https://chat.whatsapp.com/GwYF34utsnl5yocdiQJc5S) ya 😊"`;

const quickReplies = [
  "Cara main di Windows",
  "Cara main di Android",
  "Cara main di iOS",
  "Download APK",
  "Join Discord",
  "IP Server",
];

// Simple markdown renderer - renders to React elements, NOT dangerouslySetInnerHTML
function renderInlineContent(text, startKey = 0) {
  if (!text) return null;
  const parts = [];
  let remaining = text;
  let idx = startKey;

  while (remaining.length > 0) {
    const patterns = [
      { type: 'code', regex: /`([^`]+)`/ },
      { type: 'bold', regex: /\*\*(.+?)\*\*/ },
      { type: 'italic', regex: /\*(.+?)\*/ },
      { type: 'link', regex: /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/ },
      { type: 'url', regex: /https?:\/\/[^\s<>"']+/ },
    ];

    let earliest = null;
    let earliestMatch = null;

    for (const p of patterns) {
      const m = remaining.match(p.regex);
      if (m && (earliest === null || m.index < earliest)) {
        earliest = m.index;
        earliestMatch = { type: p.type, match: m };
      }
    }

    if (earliest === null || earliest > 0) {
      const textEnd = earliest !== null ? earliest : remaining.length;
      const textPart = remaining.slice(0, textEnd);
      if (textPart) parts.push(<span key={`p-${idx}`}>{textPart}</span>);
      if (earliest === null) break;
      remaining = remaining.slice(textEnd);
      continue;
    }

    const m = earliestMatch.match;
    const key = `p-${idx++}`;

    if (earliestMatch.type === 'code') {
      parts.push(<code key={key} className="bg-white/[0.1] px-1.5 py-0.5 rounded text-xs font-mono text-amber-200">{m[1]}</code>);
    } else if (earliestMatch.type === 'bold') {
      parts.push(<strong key={key} className="font-semibold text-white">{m[1]}</strong>);
    } else if (earliestMatch.type === 'italic') {
      parts.push(<em key={key} className="italic text-slate-200">{m[1]}</em>);
    } else if (earliestMatch.type === 'link') {
      parts.push(<a key={key} href={m[2]} target="_blank" rel="noreferrer" className="text-indigo-300 underline hover:text-indigo-200">{m[1]}</a>);
    } else if (earliestMatch.type === 'url') {
      const cleanUrl = m[0].replace(/["<>']+$/, '').replace(/^["<>']+/, '');
      parts.push(<a key={key} href={cleanUrl} target="_blank" rel="noreferrer" className="text-indigo-300 underline hover:text-indigo-200">{cleanUrl}</a>);
    }

    remaining = remaining.slice(m.index + m[0].length);
  }

  return parts.length ? parts : null;
}

function renderToReact(content) {
  if (!content) return null;

  let text = content
    .replace(/"\s*target="_blank"\s*rel="noreferrer"\s*class="[^"]*">\s*https?:\/\/[^\s]*/g, "")
    .replace(/\s*(?:target|rel|class|href)\s*=\s*"[^"]*"/gi, "")
    .replace(/\bnoreferrer\b/gi, "")
    .replace(/["<>']+/g, " ")
    .replace(/[^\S\n]{2,}/g, " ")
    .trim();

  const lines = text.split("\n");
  const elements = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (!line.trim()) {
      elements.push(<br key={`br-${i}`} />);
      continue;
    }

    // ### headers (handle even mid-line without newline)
    if (line.includes('###')) {
      const segments = line.split(/\s*###\s+/).filter(Boolean);
      if (segments.length > 1) {
        // First segment is paragraph text
        if (segments[0].trim()) {
          const inline = renderInlineContent(segments[0].trim(), i * 100);
          if (inline) elements.push(<div key={`intro-${i}`} className="mb-1">{inline}</div>);
        }
        // Rest are headers
        for (let s = 1; s < segments.length; s++) {
          const headerText = segments[s].replace(/^-\s*/, '').trim();
          if (headerText) {
            elements.push(
              <div key={`h-${i}-${s}`} className="text-sm font-semibold text-white mt-3 mb-1.5">
                {renderInlineContent(headerText, i * 100 + s * 10)}
              </div>
            );
          }
        }
      } else if (segments.length === 1 && line.trim().startsWith('###')) {
        elements.push(
          <div key={`h-${i}`} className="text-sm font-semibold text-white mt-3 mb-1.5">
            {renderInlineContent(line.replace(/^###\s+/, '').trim(), i * 100)}
          </div>
        );
      } else {
        const inline = renderInlineContent(line, i * 100);
        if (inline) elements.push(<div key={`line-${i}`} className="mb-1">{inline}</div>);
      }
      continue;
    }

    // Code blocks
    const codeBlockMatch = line.match(/```(\w*)\n?([\s\S]*?)```/);
    if (codeBlockMatch && codeBlockMatch.index === 0) {
      elements.push(
        <pre key={`cb-${i}`} className="bg-black/40 border border-white/10 rounded-lg p-3 my-1 text-xs overflow-x-auto font-mono text-emerald-200">
          <code>{codeBlockMatch[2]}</code>
        </pre>
      );
      continue;
    }

    // Regular line with inline formatting
    const inline = renderInlineContent(line, i * 100);
    if (inline) {
      elements.push(<div key={`line-${i}`} className="mb-1">{inline}</div>);
    }
  }

  return elements;
}

function ChatMessage({ role, content }) {
  const isBot = role === "assistant";
  return (
    <div className={`flex gap-2.5 ${isBot ? "" : "flex-row-reverse"} mb-3`}>
      <div
        className={`shrink-0 grid h-8 w-8 place-items-center rounded-full mt-0.5 overflow-hidden ring-2 ring-white/15 ${
          isBot
            ? "bg-gradient-to-br from-indigo-400 to-indigo-700"
            : "bg-gradient-to-br from-amber-400 to-amber-600"
        }`}
      >
        {isBot ? (
          <img src="https://cdn.runeria.fun/icon.png" alt="AI" className="h-full w-full object-cover" />
        ) : (
          <User className="h-4 w-4 text-white" />
        )}
      </div>
      <div
        className={`max-w-[85%] sm:max-w-[75%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed break-words overflow-hidden ${
          isBot
            ? "bg-white/[0.07] text-slate-200 rounded-tl-sm border border-white/[0.06]"
            : "bg-gradient-to-br from-amber-500/20 to-amber-600/20 text-amber-100 rounded-tr-sm border border-amber-400/15"
        }`}
      >
        {isBot ? (
          <div className="prose-custom">{renderToReact(content)}</div>
        ) : (
          <div className="whitespace-pre-wrap">{content}</div>
        )}
      </div>
    </div>
  );
}

function LoadingDots() {
  return (
    <div className="flex gap-2.5 mb-3">
      <div className="shrink-0 grid h-8 w-8 place-items-center rounded-full mt-0.5 overflow-hidden ring-2 ring-white/15 bg-gradient-to-br from-indigo-400 to-indigo-700">
        <img src="https://cdn.runeria.fun/icon.png" alt="AI" className="h-full w-full object-cover" />
      </div>
      <div className="max-w-[85%] rounded-2xl px-4 py-3 bg-white/[0.07] border border-white/[0.06] rounded-tl-sm">
        <div className="flex gap-1.5">
          <span className="h-2 w-2 rounded-full bg-slate-400 animate-bounce" style={{ animationDelay: "0ms" }} />
          <span className="h-2 w-2 rounded-full bg-slate-400 animate-bounce" style={{ animationDelay: "150ms" }} />
          <span className="h-2 w-2 rounded-full bg-slate-400 animate-bounce" style={{ animationDelay: "300ms" }} />
        </div>
      </div>
    </div>
  );
}

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const [autoOpened, setAutoOpened] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content:
        "Halo! 👋 Selamat datang di **OriginPS Support**.\n\nAda yang bisa saya bantu? Apakah kamu ingin tahu cara main, info server, atau sedang mengalami kendala?",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [showQuick, setShowQuick] = useState(true);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  // Auto open chat on page load (mobile friendly)
  useEffect(() => {
    if (!autoOpened) {
      const timer = setTimeout(() => {
        setOpen(true);
        setAutoOpened(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [autoOpened]);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, loading]);

  useEffect(() => {
    if (open && inputRef.current) {
      setTimeout(() => inputRef.current?.focus(), 300);
    }
  }, [open]);

  const sendMessage = async (text) => {
    const msg = text || input.trim();
    if (!msg || loading) return;

    setInput("");
    setShowQuick(false);

    const userMsg = { role: "user", content: msg };
    setMessages((prev) => [...prev, userMsg]);
    setLoading(true);

    try {
      const res = await fetch(API_URL + "/chat/completions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          model: MODEL,
          messages: [
            { role: "system", content: SYSTEM_PROMPT },
            ...messages
              .filter((m) => m.role !== "system")
              .map((m) => ({
                role: m.role,
                content: m.role === "assistant"
                  ? m.content
                    .replace(/<[^>]*>/g, "")
                    .replace(/###/g, "")
                    .replace(/"\s*target="_blank"\s*rel="[^"]*"\s*class="[^"]*">?/g, "")
                    .replace(/"\s*target="_blank"[^>]*/g, "")
                    .replace(/[^\S\n]{2,}/g, " ")
                    .trim()
                  : m.content,
              })),
            userMsg,
          ].slice(-20),
          temperature: 0.6,
          max_tokens: 600,
        }),
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      let reply = data.choices?.[0]?.message?.content || "Maaf, saya tidak bisa merespon saat ini. Silakan hubungi support di Discord ya 🙏";

      // Clean ALL HTML artifacts from AI response before saving to state
      reply = reply
        // Strip ### markers - model sometimes hallucinates these inline
        .replace(/###\s*/g, '')
        // Remove the entire block: " target="_blank" rel="noreferrer" class="anything">duplicateURL
        .replace(/"\s*target="_blank"\s*rel="noreferrer"\s*class="[^"]*">\s*/g, "")
        // Then remove any surviving attribute-like text
        .replace(/\s*(?:target|rel|class|href)\s*=\s*"[^"]*"/gi, "")
        .replace(/\bnoreferrer\b/gi, "")
        // Strip remaining quotes and brackets
        .replace(/["<>']+/g, " ")
        .replace(/[^\S\n]{2,}/g, " ")
        .trim();

      setMessages((prev) => [...prev, { role: "assistant", content: reply }]);
    } catch {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Maaf, terjadi error. Coba lagi atau hubungi support di Discord ya 🙏" },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleQuickReply = (q) => {
    sendMessage(q);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 grid h-14 w-14 sm:h-16 sm:w-16 place-items-center rounded-full bg-gradient-to-br from-indigo-500 to-indigo-700 text-white shadow-[0_8px_30px_-6px_rgba(99,102,241,0.6)] hover:scale-105 active:scale-95 transition-all duration-200 ring-1 ring-white/20"
        aria-label="Chat dengan OriginPS AI"
      >
        {open ? (
          <X className="h-6 w-6 sm:h-7 sm:w-7" />
        ) : (
          <MessageCircle className="h-6 w-6 sm:h-7 sm:w-7" />
        )}
        {!open && (
          <span className="absolute -top-1 -right-1 h-4 w-4 rounded-full bg-emerald-400 ring-2 ring-[#030305] animate-pulse" />
        )}
      </button>

      {/* Chat Panel */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.2, ease: [0.22, 1, 0.36, 1] }}
            className="fixed bottom-20 right-3 sm:bottom-24 sm:right-6 z-50 w-[calc(100vw-24px)] sm:w-[400px] lg:w-[420px] max-h-[70vh] sm:max-h-[600px] flex flex-col glass-card ring-border overflow-hidden rounded-2xl shadow-2xl"
          >
            {/* Header */}
            <div className="shrink-0 flex items-center gap-3 px-4 py-3.5 border-b border-white/[0.08] bg-white/[0.03]">
              <span className="relative grid h-10 w-10 place-items-center rounded-full ring-2 ring-white/20 overflow-hidden bg-gradient-to-br from-indigo-400 to-indigo-700 shadow-[0_0_12px_-2px_rgba(99,102,241,0.4)]">
                <img src="https://cdn.runeria.fun/icon.png" alt="AI" className="h-full w-full object-cover" />
                <span className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full bg-emerald-400 ring-2 ring-[#0c0c11]" />
              </span>
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-white truncate">OriginPS AI Support</div>
                <div className="text-[10px] text-emerald-400 flex items-center gap-1">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 pulse-dot" />
                  Online
                </div>
              </div>
              <button
                onClick={() => setOpen(false)}
                className="shrink-0 grid h-7 w-7 place-items-center rounded-full hover:bg-white/[0.1] transition-colors"
              >
                <ChevronDown className="h-4 w-4 text-slate-400" />
              </button>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto px-4 py-3 space-y-1 scrollbar-thin">
              {messages.map((m, i) => (
                <ChatMessage key={i} role={m.role} content={m.content} />
              ))}
              {loading && <LoadingDots />}

              {/* Quick replies */}
              {showQuick && !loading && messages.length <= 2 && (
                <div className="flex flex-wrap gap-1.5 mt-2 pb-2">
                  {quickReplies.map((q) => (
                    <button
                      key={q}
                      onClick={() => handleQuickReply(q)}
                      className="inline-flex items-center gap-1.5 rounded-full border border-white/[0.12] bg-white/[0.04] px-3 py-1.5 text-[11px] text-slate-300 hover:bg-white/[0.1] hover:text-white transition-colors"
                    >
                      {q}
                    </button>
                  ))}
                </div>
              )}

              <div ref={messagesEndRef} />
            </div>

            {/* Input */}
            <div className="shrink-0 border-t border-white/[0.08] p-3 bg-white/[0.02]">
              <div className="flex items-center gap-2">
                <input
                  ref={inputRef}
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Ketik pesan..."
                  className="flex-1 bg-white/[0.06] border border-white/[0.1] rounded-xl px-3.5 py-2.5 text-sm text-white placeholder-slate-500 outline-none focus:border-indigo-500/50 focus:ring-1 focus:ring-indigo-500/20 transition-all"
                  disabled={loading}
                />
                <button
                  onClick={() => sendMessage()}
                  disabled={!input.trim() || loading}
                  className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-700 text-white disabled:opacity-40 disabled:cursor-not-allowed hover:scale-105 active:scale-95 transition-all"
                >
                  <Send className="h-4 w-4" />
                </button>
              </div>
              <div className="mt-1.5 text-[10px] text-slate-500 text-center">
                Powered by OriginPS AI • <span className="underline cursor-pointer" onClick={() => setOpen(false)}>Tutup</span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
